/// <reference path="../../app.definition.ts" />

import angular from "angular";
import { JavaApiAdapterService } from "@common/apiadapter/javaapi.service";
import { LoggingDetail } from "@common/model/loggingDetail";

export enum LogEvent {
    DOWNLOAD_DOC = "DOWNLOAD_DOC",
    BROWSER_DOWNLOAD = "BROWSER_DOWLOAD",
    UPLOAD_DOC = "UPLOAD_DOC",
    FORM_UPLOAD_DOC = "FORM_UPLOAD_DOC",
    IE_LG_DOC_DENIED = "IE_LG_DOC_DOWNLOAD_DENIED",
}

export interface ILoggingService {
    logAction(logDetail: LoggingDetail): void;
    events: typeof LogEvent;
}

export class LoggingService implements ILoggingService {
    static $inject = ["ApiAdapterService"];
    public readonly events = LogEvent;

    constructor(private $_api: JavaApiAdapterService) { }

    public logAction(logDetail: LoggingDetail): void {
        try {
            this.$_api.logDetailToBackend(logDetail);
        } catch (e) {
            console.error("Error occurred while logging action:", e);
        }
    }
}

angular.module('eCareVault.common.services')
    .service('LoggingService', LoggingService);
